import PAYPAL from "../../assets/img/PAYPAL.png"
import BANKWIRE from "../../assets/img/BANKWIRE.png"
import CREDITCARD from "../../assets/img/CREDITCARD.png"
import SEPADEBIT from "../../assets/img/SEPADEBIT.png"
export const PaymentTypesEnum = {
	CASH: 'Bar',
	BANKWIRE: 'Überweisung',
	SEPADEBIT: 'Lastschrift',
	PAYPAL: 'Paypal',
	SOFORT: 'Sofortüberweisung',
	CREDITCARD: 'Kreditkarte (3D Secure)',
	INVOICE: 'Rechnung',
	//PAYPAL_PLUS: 'PayPal Plus',
};

export const PaymentTypesIconsEnum = {
	'PAYPAL': PAYPAL,
	'SEPADEBIT': SEPADEBIT,
	'CREDITCARD': CREDITCARD,
	'BANKWIRE': BANKWIRE
}

export default PaymentTypesEnum;
